module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"trading-name":"Razão Social"},"en-US":{"trading-name":"Trading Name"}}')
  delete Component.options._Ctor
}
